<template>
  <div class="editor-container">
    <!-- Thanh công cụ -->
    <div class="editor-toolbar">
      <button @click="editor.chain().focus().toggleBold().run()">
        <v-icon>mdi-format-bold</v-icon>
      </button>
      <button @click="editor.chain().focus().toggleItalic().run()">
        <v-icon>mdi-format-italic</v-icon>
      </button>
      <button @click="editor.chain().focus().toggleUnderline().run()">
        <v-icon>mdi-format-underline</v-icon>
      </button>
      <button @click="editor.chain().focus().toggleStrike().run()">
        <v-icon>mdi-format-strikethrough</v-icon>
      </button>
      <button @click="editor.chain().focus().toggleCode().run()">
        <v-icon>mdi-code-tags</v-icon>
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 1 }).run()">
        <v-icon>mdi-format-header-1</v-icon>
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 2 }).run()">
        <v-icon>mdi-format-header-2</v-icon>
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 3 }).run()">
        <v-icon>mdi-format-header-3</v-icon>
      </button>
      <button @click="editor.chain().focus().toggleBulletList().run()">
        <v-icon>mdi-format-list-bulleted</v-icon>
      </button>
      <button @click="editor.chain().focus().toggleOrderedList().run()">
        <v-icon>mdi-format-list-numbered</v-icon>
      </button>
      <button @click="editor.chain().focus().toggleBlockquote().run()">
        <v-icon>mdi-format-quote-close</v-icon>
      </button>
      <button @click="editor.chain().focus().setHorizontalRule().run()">
        <v-icon>mdi-minus</v-icon>
      </button>
      <button @click="editor.chain().focus().setTextAlign('left').run()">
        <v-icon>mdi-format-align-left</v-icon>
      </button>
      <button @click="editor.chain().focus().setTextAlign('center').run()">
        <v-icon>mdi-format-align-center</v-icon>
      </button>
      <button @click="editor.chain().focus().setTextAlign('right').run()">
        <v-icon>mdi-format-align-right</v-icon>
      </button>
      <button @click="editor.chain().focus().setTextAlign('justify').run()">
        <v-icon>mdi-format-align-justify</v-icon>
      </button>
      <button @click="insertImage">
        <v-icon>mdi-image</v-icon>
      </button>
      <button @click="insertTable">
        <v-icon>mdi-table</v-icon>
      </button>
      <button @click="editor.chain().focus().deleteTable().run()">
        Xóa bảng
      </button>
      <button @click="editor.chain().focus().undo().run()">
        <v-icon>mdi-undo</v-icon>
      </button>
      <button @click="editor.chain().focus().redo().run()">
        <v-icon>mdi-redo</v-icon>
      </button>
    </div>

    <!-- Editor content -->
    <editor-content :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Image from '@tiptap/extension-image'
import Table from '@tiptap/extension-table'
import TableRow from '@tiptap/extension-table-row'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import Underline from '@tiptap/extension-underline'
import TextAlign from '@tiptap/extension-text-align'

export default {
  components: {
    EditorContent,
  },
  
  data() {
    return {
      editor: null,
    }
  },

  mounted() {
    this.editor = new Editor({
      extensions: [
        StarterKit,
        Image,
        Table.configure({
          resizable: true,
        }),
        TableRow,
        TableCell,
        TableHeader,
        Underline,
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
      ],
      content: '<p>Nhập nội dung tại đây...</p>',
      editable: true,
      onUpdate: () => {
        this.$emit('update')
      }
    })
  },

  beforeDestroy() {
    this.editor.destroy()
  },

  methods: {
    insertImage() {
      const url = prompt('Nhập URL hình ảnh:')
      if (url) {
        this.editor.chain().focus().setImage({ src: url }).run()
      }
    },

    insertTable() {
      this.editor.chain()
        .focus()
        .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
        .run()
    }
  }
}
</script>

<style>
.editor-container {
  border: 1px solid #ddd;
  border-radius: 4px;
}

.editor-toolbar {
  padding: 0.5rem;
  border-bottom: 1px solid #ddd;
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.editor-toolbar button {
  padding: 0.5rem;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.editor-toolbar button:hover {
  background: #e9ecef;
}

.ProseMirror {
  padding: 1rem;
  min-height: 200px;
  outline: none;
}

.ProseMirror table {
  border-collapse: collapse;
  margin: 0;
  overflow: hidden;
  table-layout: fixed;
  width: 100%;
}

.ProseMirror td,
.ProseMirror th {
  border: 2px solid #ced4da;
  box-sizing: border-box;
  min-width: 1em;
  padding: 3px 5px;
  position: relative;
  vertical-align: top;
}

.ProseMirror img {
  max-width: 100%;
  height: auto;
}
</style>
